import LayoutStatistics from './LayoutStatistics.vue'
export default LayoutStatistics



// WEBPACK FOOTER //
// ./src/layouts/layoutStatistics/index.js